export default __webpack_public_path__ + "static/media/mockup-CD+tee-d2c.ec6cb250.png";